import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Download } from '@phosphor-icons/react';

/**
 * PdfPreviewDialog
 * Renders a modal with an <iframe> showing the PDF inline.
 * `url` must be a relative `/api/...` path so cookie auth travels with the request.
 */
const PdfPreviewDialog = ({ open, onOpenChange, url, title = 'Preview', filename }) => {
  if (!url) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl w-[95vw] h-[90vh] flex flex-col p-0 gap-0" data-testid="pdf-preview-dialog">
        <DialogHeader className="px-6 py-4 border-b border-gray-200 flex flex-row items-center justify-between space-y-0">
          <DialogTitle className="text-base font-semibold truncate pr-4">
            {title}
            {filename && <span className="text-sm font-normal text-gray-500 ml-2">— {filename}</span>}
          </DialogTitle>
          <DialogDescription className="sr-only">Inline PDF preview. Use the Download button to save a copy.</DialogDescription>
          <a href={url} target="_blank" rel="noopener noreferrer" download={filename} className="mr-8">
            <Button variant="outline" size="sm" className="rounded-none" data-testid="pdf-preview-download-btn">
              <Download className="w-4 h-4 mr-2" /> Download
            </Button>
          </a>
        </DialogHeader>
        <div className="flex-1 bg-gray-100 overflow-hidden">
          <iframe
            src={url}
            title={title}
            className="w-full h-full border-0"
            data-testid="pdf-preview-iframe"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PdfPreviewDialog;
